export default "__VITE_ASSET__ClkyTQJ5__"